import React from 'react';
import { Redirect } from 'react-router-dom';
import { DeviceDomain } from 'models/Device';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AppState } from 'stores/type';
import { ROUTER_PATH } from 'views/constants';

export const RequiredAuthentication: React.FC = ({ children }) => {
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const device = useSelector((state) => state.deviceState.device);
  const deviceDomain = new DeviceDomain(device);

  return deviceDomain.isAuthenticated() ? (
    <>{children}</>
  ) : (
    <Redirect to={ROUTER_PATH.login} />
  );
};
